import { AddContactType } from "./addContact.types";

export const ADD_CONTACT_MODAL_WIDTH = "512px";

export const ADD_CONTACT_INPUT_CLASSES =
  "font-medium text-[#333333] placeholder:font-medium placeholder:text-[rgba(51,51,51,0.6)]";

export const CONTACT_TYPE_OPTIONS: {
  type: AddContactType;
  title: string;
  description: string;
}[] = [
  {
    type: "individual",
    title: "Individual",
    description: "A person, plus spouse and dependants",
  },
  {
    type: "organization",
    title: "Organization",
    description: "Corporations, Sole Proprietors, Trust and more",
  },
];
